import React, { useState, useEffect, useContext, useRef } from "react";
import EmpresaContext from "../../../../../contexts/Empresa";
import api from "../../../../../services/api";
import { AxiosResponse } from "axios";
import { SpinnerContainer } from "../styles";

import { Ranking } from "./PlayneeRanking";

function RankingEmpresas({
  notify,
  mes,
  ano,
  tipoProduto,
  unidade,
  setCardHeight,
}) {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(false);

  const [pageProperties, setPageProperties] = useState({
    total: "0",
    perPage: 5,
    page: 1,
    lastPage: 1,
    loading: false,
    showSizePerPage: false,
  });

  const tableRef = useRef(null);

  useEffect(() => {
    setCardHeight(tableRef.current.firstChild.clientHeight);
  }, [itens]);

  useEffect(() => {
    loadRanking();
  }, [mes, ano, tipoProduto, unidade, empresaSelecionada]);

  async function updatePageProperties(response) {
    const { total, perPage, page, lastPage } = await response.data;
    setPageProperties({
      total,
      perPage,
      page,
      lastPage,
      loading: false,
      showSizePerPage: false,
    });
  }

  async function loadRanking(
    page = 1,
    limit = 50,
    sortField = "vendas_geral",
    sortOrder = "desc"
  ) {
    try {
      setPageProperties({
        ...pageProperties,
        loading: true,
      });

      const response = await api.get(
        `/dashboards/empresas/${empresaSelecionada.id}/ranking-empresas`,
        {
          params: {
            mes,
            ano,
            unidade,

            page,
            limit,
            sortField,
            sortOrder,
          },
        }
      );

      console.log("Dados recebidos do backend:", response.data.data);

      const sortedEmpresas = [...response.data.data].sort((a, b) => {
        const percentA = a.meta_geral > 0 ? a.vendas_geral / a.meta_geral : 0;
        const percentB = b.meta_geral > 0 ? b.vendas_geral / b.meta_geral : 0;
        return percentB - percentA;
      });

      setItens(sortedEmpresas);
      await updatePageProperties(response);
    } catch (err) {
      console.log(err.response);
      notify("danger", "Houve um problema ao carregar o Ranking de Empresas.");
    }
  }

  async function handleTableChange(type, sortProperties) {
    try {
      await loadRanking(
        sortProperties.page == 0 ? 1 : sortProperties.page,
        sortProperties.sizePerPage,
        sortProperties.sortField,
        sortProperties.sortOrder
      );
    } catch (error) {
      notify("danger", "Houve um problema ao atualizar o Ranking.");
    }
  }

  return (
    <span ref={tableRef}>
      <Ranking empresas={itens || []} unidade={unidade} />
    </span>
  );
}

export default RankingEmpresas;
